const DEV_DEFAULT = 'http://127.0.0.1:9001';

/**
 * Bazë URL për API.
 * 1) REACT_APP_BACKEND_URL nëse është vendosur në build (p.sh. lokal).
 * 2) Përndryshe i njëjti origin si faqja (e njëjta për tested.dioiot.com / dio.dioiot.com pa gabim CORS).
 * 3) Fallback për teste / SSR.
 */
export function getBackendUrl() {
  const raw = process.env.REACT_APP_BACKEND_URL;
  const fromEnv = typeof raw === 'string' ? raw.trim() : '';
  if (fromEnv) return fromEnv.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return DEV_DEFAULT;
}
